import { chatListActions } from './ChatListActions';


const initState = {
    showSpinner: true,
    chatList: [],
    ReceiversList: [],
    error: null,
    currentPage: 1,
    totalPages: 1,
    chatsCount: 0,
    addMessageState: false,
    showSearchReceiver: false,
    searchSpinner: false,
    selectedReceiver: null,
    messageContent: '',
    messageAttachment: null,
    showEmojis: false,
    messageAttachmentName: ''
}


export default function chatListPageReducer(state = initState, action) {
    switch (action.type) {
        case chatListActions.toggleSpinner:
            return toggleSpinner(state, action);
        case chatListActions.showSearchSpinner:
            return showSearchSpinner(state, action)
        case chatListActions.hideSearchSpinner:
            return hideSearchSpinner(state, action)
        case chatListActions.setError:
            return setError(state, action);
        case chatListActions.setChatList:
            return setChatList(state, action);
        case chatListActions.setCurrentPage:
            return setCurrentPage(state, action);
        case chatListActions.setTotalPages:
            return setTotalPages(state, action);
        case chatListActions.setChatsCount:
            return setChatsCount(state, action);
        case chatListActions.activeAddMessageState:
            return activeAddMessageState(state, action);
        case chatListActions.setShowSearchReceiver:
            return setShowSearchReceiver(state, action);
        case chatListActions.setUsersList:
            return setUsersList(state, action) 
        case chatListActions.setSelectedReceiver:
            return setSelectedReceiver(state, action)
        case chatListActions.setMessageContent:
            return setMessageContent(state, action)
        case chatListActions.setMessageAttachment:
            return setMessageAttachment(state, action)
        case chatListActions.toggleShowEmojis:
            return toggleShowEmojis(state, action)
        case chatListActions.hideEmojis:
            return hideEmojis(state)
        case chatListActions.removeMessageAttachment:
            return removeMessageAttachment(state)
        case chatListActions.setMessageAttachmentName:
            return setMessageAttachmentName(state, action)
        default:
            return state;
    }
}

function setMessageAttachmentName(state, { payload }) {
    return {
        ...state,
        messageAttachmentName: payload
    }
}

function removeMessageAttachment(state) {
    return {
        ...state,
        messageAttachment: null
    }
}

function hideEmojis(state) {
    return {
        ...state,
        showEmojis: false
    }
}

function toggleShowEmojis(state, { payload }) {
    return {
        ...state,
        showEmojis: payload
    }
}

function setMessageAttachment(state, { payload }) {
    return {
        ...state,
        messageAttachment: payload
    }
}

function setMessageContent(state, { payload }) {
    return {
        ...state,
        messageContent: payload
    }
}

function setSelectedReceiver(state, { payload }) {
    return {
        ...state, 
        selectedReceiver: payload
    }
}

function hideSearchSpinner(state) {
    return {
        ...state,
        searchSpinner: false
    }
}

function showSearchSpinner(state) {
    return {
        ...state,
        searchSpinner: true,
    }
}

function activeAddMessageState(state, { payload }) {
    return {
        ...state,
        addMessageState: payload,
    }
}

function setShowSearchReceiver(state, { payload }) {
    return {
        ...state,
        showSearchReceiver: payload,
    }
}

function setChatList(state, { payload }) {
    return {
        ...state,
        chatList: payload,
    }
}

function setUsersList(state, { payload }) {
    return {
        ...state,
        ReceiversList: payload,
    }
}

function setError(state, { payload }) {
    return {
        ...state,
        error: payload,
    }
}

function toggleSpinner(state, { payload }) {
    return {
        ...state,
        showSpinner: payload
    }
}

function setCurrentPage(state, { payload }) {
    return {
        ...state,
        currentPage: payload
    }
}

function setTotalPages(state, { payload }){
    return {
        ...state,
        totalPages: payload
    }
}

function setChatsCount(state, { payload }){
    return {
        ...state,
        chatsCount: payload
    }
}
